module.exports = " <div class=hello _v-1408fa30=\"\"> <img class=logo src=" + require("../assets/logo_w.jpg") + " _v-1408fa30=\"\"> <div class=welcome _v-1408fa30=\"\"> <h1 class=\"big_header cssa7d0b7c7315c17\" _v-1408fa30=\"\">{{ msg }}</h1> <h4 _v-1408fa30=\"\">{{ chi_msg }}</h4> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-1408fa30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 21
// module chunks = 1